import { render, staticRenderFns } from "./ClustersListItem.vue?vue&type=template&id=4a6675f6&"
import script from "./ClustersListItem.vue?vue&type=script&lang=js&"
export * from "./ClustersListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports